import styles from './styles/index.module.scss';

type Props = {
  name: string,
  required?: boolean,
  array: {
    value: number | '',
    text: string,
  }[],
  onChange: React.FormEventHandler<HTMLSelectElement>,
  value: number | '',
};

export default function Select({ name, required, array, onChange, value }: Props ) {

  return (
    <select className={styles.select} name={name} onChange={onChange} value={value} required={required}>
      {
        array.map(({ value: v, text}) => {
          return (
            <option key={v} value={v}>{text}</option>
          );
        })
      }
    </select>

  );
}